import { Typography } from "@mui/material"
import { Box } from "@mui/system"

const MapsInsightDefinition = ({rowData}: any) => {
  // Parse JSON strings for better display
  const parseJsonSafely = (jsonString: string) => {
    try {
      return JSON.stringify(JSON.parse(jsonString), null, 2);
    } catch {
      return jsonString; // Return as-is if parsing fails
    }
  };

  return (
    <>
    <Box px={18} py={2}>
        <Typography textAlign={"left"} sx={{color:"#000000DE"}}>
            <span style={{color:'#00000099', fontSize:'14px'}}>Filtering Definition</span>
            <pre style={{margin:'5px 0px'}}>
              {rowData?.filtering_definition ? parseJsonSafely(rowData.filtering_definition) : 'N/A'}
            </pre>
        </Typography>

        <Typography textAlign={"left"} sx={{color:"#000000DE"}}>
            <span style={{color:'#00000099', fontSize:'14px'}}>Unique Definition</span>
            <pre style={{margin:'5px 0px'}}>
              {rowData?.unique_definition ? parseJsonSafely(rowData.unique_definition) : 'N/A'}
            </pre>
        </Typography>
    </Box>
    </>
  )
}

export default MapsInsightDefinition
